module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_8011.a5e3e54f.png";